/**
 * Pure helpers lifted verbatim out of use-resizer.js, where the same logic was
 * duplicated in stopResize and mouseUp. The group overlay commits geometry through
 * the same path single-element gestures use, so this had to become shared code.
 *
 * Behaviour is identical to the inline versions these replace, quirks included:
 * type detection is substring-based, and the style regex splits only on semicolons.
 */

/** Parse an element's `style` attribute into a plain object. */
export const parseStyleAttribute = (cssStyle) => {
  const updatedStyle = {};
  if (!cssStyle) return updatedStyle;
  const regex = /([\w-]*)\s*:\s*([^;]*)/g;
  let match;
  while ((match = regex.exec(cssStyle))) {
    updatedStyle[match[1]] = match[2].trim();
  }
  return updatedStyle;
};

/** Slide-object type inferred from the element id. Order is significant. */
export const resolveElementType = (eleId) =>
  eleId.includes('smartart')
    ? 'smartart'
    : eleId.includes('wordart')
      ? 'wordart'
      : eleId.includes('text') || eleId.includes('layout')
        ? 'text'
        : eleId.includes('image')
          ? 'image'
          : 'shape';

/** The stored record for an element, or null when the slide has no such entry. */
export const getExistingData = (type, currentSlideId, eleId, existingSlides) => {
  switch (type) {
    case 'text':
      return existingSlides[currentSlideId].textBox[eleId] || null;
    case 'image':
      return existingSlides[currentSlideId].image[eleId] || null;
    case 'shape':
      return existingSlides[currentSlideId].shapes[eleId] || null;
    case 'wordart':
      return existingSlides[currentSlideId]?.wordArtTextObjects?.[eleId] || null;
    case 'smartart':
      return existingSlides[currentSlideId]?.smartArtObjects?.[eleId] || null;
    default:
      return null;
  }
};
